import { render, staticRenderFns } from "./EformElementEditLinkedForm.vue?vue&type=template&id=048f015d&"
import script from "./EformElementEditLinkedForm.vue?vue&type=script&lang=js&"
export * from "./EformElementEditLinkedForm.vue?vue&type=script&lang=js&"
import style0 from "./EformElementEditLinkedForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports